import { getExtraDriveVolumesInfo } from '../helpers'
import { ACTION_LIMITATION_TOOLTIPS } from '../tooltipConstants'

export const ATTACHED_STATES = ['stopped'] as const

export const canIsoMount = (vm) => {
  return (
    ATTACHED_STATES.includes(vm?.state as any) &&
    !vm?.['OS-EXT-STS:task_state'] &&
    vm?.locked === false
  )
}

export const canUnMountIso = (vm) => {
  const { hasExtraDrives } = getExtraDriveVolumesInfo(vm)
  return (
    ATTACHED_STATES.includes(vm?.state as any) &&
    !vm?.['OS-EXT-STS:task_state'] &&
    vm?.locked === false &&
    hasExtraDrives
  )
}

export const disableMountIsoTooltip = (vm) => {
  if (vm?.['OS-EXT-STS:task_state']) {
    return ACTION_LIMITATION_TOOLTIPS.MOUNT_ISO_ACTIVE_TASK
  }
  if (vm?.locked) {
    return ACTION_LIMITATION_TOOLTIPS.MOUNT_ISO_LOCKED_VM
  }
  if (!ATTACHED_STATES.includes(vm?.state as any)) {
    return ACTION_LIMITATION_TOOLTIPS.MOUNT_ISO_VM_NOT_STOPPED
  }
  return ''
}

export const disabledUnMountIsoTooltip = (vm) => {
  const { hasExtraDrives } = getExtraDriveVolumesInfo(vm)

  if (vm?.['OS-EXT-STS:task_state']) {
    return ACTION_LIMITATION_TOOLTIPS.UNMOUNT_ISO_ACTIVE_TASK
  }
  if (vm?.locked) {
    return ACTION_LIMITATION_TOOLTIPS.UNMOUNT_ISO_LOCKED_VM
  }
  if (!ATTACHED_STATES.includes(vm?.state as any)) {
    return ACTION_LIMITATION_TOOLTIPS.UNMOUNT_ISO_VM_NOT_STOPPED
  }
  if (!hasExtraDrives) {
    return ACTION_LIMITATION_TOOLTIPS.UNMOUNT_ISO_NO_ISO
  }
  return ''
}
